<template>
  <div class="base-timer">
    <span class="base-timer__label">{{ formattedTimeLeft }}</span>
  </div>
</template>

<script>

    export default {
        data() {
            return {
                timePassed: 0,
                timerInterval: null
            }
        },

        props: {
            time_limit: {
                type: Number,
                default: 0
            },
            started: {
                type: Boolean,
                default: false
            }
        },

        computed: {

            formattedTimeLeft() {
                const timeLeft = this.timeLeft;
                const minutes = Math.floor(timeLeft / 60);
                let seconds = timeLeft % 60;

                if (seconds < 10) {
                    seconds = `0${seconds}`;
                }

                return `${minutes}:${seconds}`
            },

            timeLeft() {
                return this.time_limit - this.timePassed;
            }
        },

        watch: {
            timeLeft(newValue) {
                if (newValue === 0) {
                    this.onTimesUp();
                }
            },

            started(value) {
                if(value) {
                    this.startTimer()
                }
                else {
                    this.timePassed = 0
                    this.onTimesUp()
                    this.$router.push({
                        name: 'tours-search'
                    })
                }
            }
        },

        // mounted() {
        //     this.startTimer();
        // },

        methods: {
            onTimesUp() {
                clearInterval(this.timerInterval)
            },

            startTimer() {
                this.timerInterval = setInterval(() => (this.timePassed += 1), 1000)
            }
        },

        created() {

        }
    }
</script>

<style lang="scss">
    .base-timer {
        &__label {
            font-size: 48px;
        }
    }
</style>